export default __webpack_public_path__ + "static/media/admob-320x50.0b0fe858.png";